var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 45.6863V45.8863H5.53334H19.4372C20.3028 45.8863 21.0038 46.5873 21.0038 47.453C21.0038 48.3186 20.3028 49.0196 19.4372 49.0196H5.53334C3.69605 49.0196 2.2 47.5236 2.2 45.6863V9.77632C2.2 8.88626 2.54557 8.04955 3.17688 7.42033L3.17711 7.42009L9.42009 1.17711L9.42032 1.17688C10.0496 0.54559 10.8863 0.2 11.7763 0.2H40.5134C42.3506 0.2 43.8467 1.69605 43.8467 3.53334V17.6316C43.8467 18.4973 43.1457 19.1983 42.28 19.1983C41.4144 19.1983 40.7134 18.4973 40.7134 17.6316V3.53334V3.33334H40.5134H16.087H15.887V3.53334V10.5604C15.887 12.3977 14.3909 13.8938 12.5536 13.8938H5.53334H5.33334V14.0938V45.6863ZM11.7763 3.3339H11.6935L11.6349 3.39248L5.39191 9.63563L5.33334 9.69421V9.77705V10.561V10.761H5.53334H12.5536H12.7536V10.561V3.5339V3.3339H12.5536H11.7763Z",
    fill: "#146C94",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1783 49.4667V49.6667H27.3783H47.5867H47.7867L47.7867 49.4666L47.7845 25.5768L47.7844 25.3768H47.5845H27.3783H27.1783V25.5768V49.4667ZM27.3783 22.2435H47.5845C49.424 22.2435 50.9178 23.7373 50.9178 25.5768V49.4667C50.9178 51.304 49.4218 52.8 47.5845 52.8H27.3783C25.541 52.8 24.045 51.304 24.045 49.4667V25.5768C24.045 23.7395 25.541 22.2435 27.3783 22.2435Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8067 29.6126H42.159C43.0226 29.6126 43.7257 30.3138 43.7257 31.1793C43.7257 32.0449 43.0247 32.7459 42.159 32.7459H32.8067C31.9411 32.7459 31.24 32.0449 31.24 31.1793C31.24 30.3136 31.9411 29.6126 32.8067 29.6126Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5264 36.262H34.423C35.2866 36.262 35.9897 36.9632 35.9897 37.8287C35.9897 38.6943 35.2886 39.3953 34.423 39.3953H33.5264C32.6608 39.3953 31.9598 38.6943 31.9598 37.8287C31.9598 36.963 32.6608 36.262 33.5264 36.262Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5401 36.262H41.4389C42.3066 36.262 43.0055 36.9629 43.0055 37.8287C43.0055 38.6943 42.3045 39.3953 41.4389 39.3953H40.5401C39.6745 39.3953 38.9734 38.6943 38.9734 37.8287C38.9734 36.963 39.6745 36.262 40.5401 36.262Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5264 42.2952H34.423C35.2868 42.2952 35.9897 42.9944 35.9897 43.8619C35.9897 44.7275 35.2886 45.4286 34.423 45.4286H33.5264C32.6608 45.4286 31.9598 44.7275 31.9598 43.8619C31.9598 42.9962 32.6608 42.2952 33.5264 42.2952Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5401 42.2952H41.4389C42.3067 42.2952 43.0055 42.994 43.0055 43.8619C43.0055 44.7275 42.3045 45.4286 41.4389 45.4286H40.5401C39.6745 45.4286 38.9734 44.7275 38.9734 43.8619C38.9734 42.9962 39.6745 42.2952 40.5401 42.2952Z",
    fill: "#19A7CE",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.fb1e31464c4d9b5d44d4902a187ebda4.svg";
export { ForwardRef as ReactComponent };